// extracted by mini-css-extract-plugin
export default {"wrapper":"print-pdf_wrapper__xgaUd","button":"print-pdf_button__EQmce"};